<template>
<div class="chapter">
<div class="inner_page">
<h1 class="btnew"><a id="page_iii"></a>LIGHTNINGS</h1>
<h1 class="btnew1">TO <span class="btnewj">SPITFIRES</span></h1>
<p class="subtitle">MEMOIRS OF AN RAF FIGHTER PILOT AND FORMER</p>
<p class="subtitle1">OFFICER COMMANDING THE BATTLE OF BRITAIN</p>
<p class="subtitle1">MEMORIAL FLIGHT</p>
<p class="aut">CLIVE ROWLEY</p>
<div class="img_container">
<img alt="images" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?c5d4822a